export const analyticsQueue: any[] = [];

export let consentReady = false;

export function setConsentReady(val: boolean) {
  consentReady = val;
}

export function flushAnalyticsQueue() {
  while (consentReady && analyticsQueue.length) {
    window.dataLayer.push(analyticsQueue.shift());
  }
}
export function pushEvent(obj: any) {
  analyticsQueue.push(obj);
  if (consentReady) flushAnalyticsQueue();
}
